import { CSS, Text } from '@ghq-abi/design-system';

interface JobTitleProps {
  text?: string;
  css?: CSS;
}

export function SecondaryText({ text, css }: JobTitleProps) {
  if (!text) return null;

  return (
    <Text
      title={text}
      css={{
        maxHeight: 36,
        limitLines: 1,
        fontSize: '$xs',
        color: '$gray575',
        ...css,
      }}
    >
      {text}
    </Text>
  );
}
